(function(){
  function init(){
    document.querySelectorAll('[data-related-products]').forEach(function(root){
      var url = root.getAttribute('data-url');
      if(!url) return;
      fetch(url)
        .then(function(r){ return r.ok ? r.text() : Promise.reject(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-related-products-grid]');
          var grid = root.querySelector('[data-related-products-grid]');
          if(newGrid && grid && newGrid.children.length){
            grid.innerHTML = newGrid.innerHTML;
            root.hidden = false;
          }
        })
        .catch(function(){});
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
